module.exports = __webpack_public_path__ + "static/media/ios_fb_browser.5f03867a.png";